import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { FestiveDayItemMaintenanceDto } from './FestiveDayItemMaintenanceDto';
import { FestiveDayListMaintenanceDto } from './FestiveDayListMaintenanceDto';


@Injectable()
export class FestiveDaySubMaintenanceController extends BaseSubMaintenanceController<FestiveDayListMaintenanceDto, FestiveDayItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "festives/day");
    }

    public getResourceRoot(): string {
        return "FESTIVES.DAY";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/dataandparameters/festives/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
